import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"




export default /*#__PURE__*/_defineComponent({
  __name: 'RenderTextarea',
  props: ['item'],
  setup(__props) {

const props = __props;



return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!

  return (_openBlock(), _createBlock(_component_el_input, _mergeProps({
    autosize: { minRows: 2 },
    type: "textarea"
  }, _ctx.$attrs), null, 16))
}
}

})